import { useState } from "react";
import { Avatar, Ic, ICONS } from "../components/UI.jsx";
import { useUIStore } from "../context/store.js";

const B = {
  bg2:"#0D0C18",bg3:"#131124",
  violet:"#7C3AED",violetLt:"#8B5CF6",
  violetDim:"rgba(124,58,237,0.15)",violetBorder:"rgba(124,58,237,0.3)",
  vibeGreen:"#10F5A0",vibeGreenDim:"rgba(16,245,160,0.12)",
  coral:"#FF6B6B",coralDim:"rgba(255,107,107,0.12)",
  amber:"#FFB830",sky:"#38BDF8",purple:"#A78BFA",
  text:"#F0EFFE",text2:"#7C7A9E",text3:"#3D3B5C",
  border2:"rgba(124,58,237,0.08)",
  grad:"linear-gradient(135deg,#7C3AED,#10F5A0)",
  font:"'Sora',system-ui,sans-serif",mono:"'Space Mono',monospace",
};

const DEMO_ALERTS = [
  { id:1, icon:"❤️", user:{displayName:"Aisha Kamara",initials:"AK",color:"#10F5A0",verified:true}, text:"vibed your post about #DAOs", time:"2m", isNew:true, type:"like" },
  { id:2, icon:"💬", user:{displayName:"Leon Chen",initials:"LC",color:"#38BDF8",verified:true}, text:"mentioned you in a Space: Building Your Second Brain", time:"1h", isNew:true, type:"mention" },
  { id:3, icon:"📩", user:{displayName:"Jade Nakamura",initials:"JN",color:"#FFB830",verified:true}, text:"invited you to collector preview at 9PM EST", time:"2h", isNew:false, type:"invite" },
  { id:4, icon:"💌", user:{displayName:"Marcus Osei",initials:"MO",color:"#A78BFA",verified:true}, text:"sent you a connect message", time:"3h", isNew:false, type:"dm" },
  { id:5, icon:"➕", user:{displayName:"Remi Kowalski",initials:"RK",color:"#FF6B6B"}, text:"started connecting with you", time:"5h", isNew:false, type:"follow" },
  { id:6, icon:"🔁", user:{displayName:"Tanvi Patel",initials:"TP",color:"#A78BFA"}, text:"reshared your post about #HumanPotential", time:"6h", isNew:false, type:"repost" },
  { id:7, icon:"❤️", user:{displayName:"Sena Osei",initials:"SO",color:"#2DD4BF"}, text:"vibed your post about AgriTech", time:"8h", isNew:false, type:"like" },
  { id:8, icon:"🎙️", user:{displayName:"Leon Chen",initials:"LC",color:"#38BDF8",verified:true}, text:"went live: Building Your Second Brain in 2026", time:"1d", isNew:false, type:"space" },
];

const typeColor = { like:B.coral, mention:B.vibeGreen, invite:B.amber, dm:B.violet, follow:B.sky, repost:B.vibeGreen, space:B.purple };

export default function AlertsPage() {
  const { markAlertsRead } = useUIStore();
  const [activeTab, setActiveTab] = useState("all");
  const [alerts, setAlerts] = useState(DEMO_ALERTS);

  const filteredAlerts = activeTab === "all" ? alerts
    : activeTab === "mentions" ? alerts.filter(a => a.type === "mention")
    : alerts.filter(a => a.type === "space");

  const markAllRead = () => {
    setAlerts(prev => prev.map(a => ({...a, isNew:false})));
    markAlertsRead();
  };

  return (
    <div style={{ display:"flex",flexDirection:"column",height:"100%",overflow:"hidden" }}>
      {/* Header */}
      <div style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:"14px 16px",borderBottom:`1px solid ${B.border2}`,flexShrink:0 }}>
        <span style={{ fontWeight:900,fontSize:22,color:B.text }}>Vibes & Alerts</span>
        <div style={{ display:"flex",gap:8 }}>
          <button onClick={markAllRead} style={{ padding:"6px 14px",borderRadius:9999,border:`1px solid ${B.border2}`,background:"none",color:B.text2,cursor:"pointer",fontFamily:B.font,fontSize:13 }}>
            Mark all read
          </button>
          <button style={{ width:34,height:34,borderRadius:"50%",border:"none",background:B.bg3,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center" }}>
            <Ic d={ICONS.settings} s={16} c={B.text2} />
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display:"flex",borderBottom:`1px solid ${B.border2}`,flexShrink:0 }}>
        {[["all","All"],["mentions","Mentions"],["spaces","Spaces"]].map(([k,l])=>(
          <button key={k} onClick={()=>setActiveTab(k)} style={{
            flex:1,padding:"13px 0",textAlign:"center",fontSize:14,
            fontWeight:activeTab===k?700:400,color:activeTab===k?B.text:B.text2,
            border:"none",background:"none",cursor:"pointer",fontFamily:B.font,
            borderBottom:activeTab===k?`3px solid ${B.violet}`:"3px solid transparent",
          }}
            onMouseEnter={e=>e.currentTarget.style.background=B.violetDim}
            onMouseLeave={e=>e.currentTarget.style.background="none"}>{l}</button>
        ))}
      </div>

      {/* Alerts list */}
      <div style={{ flex:1,overflowY:"auto" }}>
        {filteredAlerts.length === 0 ? (
          <div style={{ padding:48,textAlign:"center" }}>
            <div style={{ fontSize:48,marginBottom:16 }}>🔔</div>
            <div style={{ fontWeight:700,fontSize:20,color:B.text,marginBottom:8 }}>All caught up!</div>
            <div style={{ color:B.text2 }}>No {activeTab !== "all" ? activeTab : ""} alerts yet</div>
          </div>
        ) : (
          filteredAlerts.map((a,i) => {
            const color = typeColor[a.type] || B.violet;
            return (
              <div key={a.id||i} onClick={()=>setAlerts(prev=>prev.map(al=>al.id===a.id?{...al,isNew:false}:al))} style={{
                display:"flex",gap:12,padding:"15px 16px",borderBottom:`1px solid ${B.border2}`,cursor:"pointer",
                background:a.isNew?`rgba(124,58,237,0.06)`:"none",
                borderLeft:a.isNew?`3px solid ${B.violet}`:"3px solid transparent",
                transition:"background 0.15s",
              }}
                onMouseEnter={e=>e.currentTarget.style.background=B.violetDim}
                onMouseLeave={e=>e.currentTarget.style.background=a.isNew?`rgba(124,58,237,0.06)`:"none"}>
                {/* Notif icon */}
                <div style={{ width:42,height:42,borderRadius:"50%",background:`${color}12`,border:`1px solid ${color}25`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0 }}>
                  {a.icon}
                </div>
                <div style={{ flex:1,minWidth:0 }}>
                  <div style={{ display:"flex",alignItems:"flex-start",justifyContent:"space-between",gap:8 }}>
                    <div style={{ flex:1 }}>
                      <Avatar user={a.user} size={28} />
                    </div>
                    <div style={{ display:"flex",alignItems:"center",gap:6,flexShrink:0 }}>
                      <span style={{ fontSize:12,color:B.text2,fontFamily:B.mono }}>{a.time} ago</span>
                      {a.isNew && <div style={{ width:8,height:8,borderRadius:"50%",background:B.violet,boxShadow:`0 0 6px ${B.violet}` }} />}
                    </div>
                  </div>
                  <div style={{ fontSize:14,marginTop:6,lineHeight:1.5,color:B.text }}>
                    <strong style={{ color:a.user.color }}>{a.user.displayName}</strong>
                    {a.user.verified&&<span style={{ color:B.violet,marginLeft:3,fontSize:12 }}>✓</span>}
                    {" "}{a.text}
                  </div>
                </div>
              </div>
            );
          })
        )}

        {/* Settings suggestion */}
        <div style={{ margin:20,padding:20,borderRadius:16,background:B.bg3,border:`1px solid ${B.border2}`,display:"flex",alignItems:"center",gap:14 }}>
          <div style={{ width:44,height:44,borderRadius:12,background:B.violetDim,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0 }}>
            <Ic d={ICONS.bell} s={22} c={B.violetLt} />
          </div>
          <div style={{ flex:1 }}>
            <div style={{ fontWeight:700,fontSize:15,color:B.text,marginBottom:3 }}>Alert preferences</div>
            <div style={{ fontSize:13,color:B.text2 }}>Customize which vibes and alerts you receive</div>
          </div>
          <button style={{ padding:"7px 16px",borderRadius:9999,border:`1px solid ${B.violetBorder}`,background:B.violetDim,color:B.violetLt,fontFamily:B.font,fontWeight:700,fontSize:13,cursor:"pointer",flexShrink:0 }}>
            Manage
          </button>
        </div>
      </div>
    </div>
  );
}
